'use strict';

angular.module('webAgro1App').controller('IntegracaoPluviometrosCtrl', function($scope, $location, $rootScope, PluviometrosService, Flash, LoadingService, MessagesService, PluviometrosIntegracaoService) {

  var textType = /zip.*/;

  $scope.reset = function() {
    $scope.parametros = {
      tipo: 'pluviografo'
    };
    $scope.pluviometroFile = null;
    angular.element("input[type='file']").val(null);
  };

  var initialize = function() {
    LoadingService.showLoading();
    $scope.reset();
    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.clima.integracaoPluviometros) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      $scope.listPluviometrosPropriedade();
    }, $rootScope.errorRootInitialize);
  };

  $scope.listPluviometrosPropriedade = function() {
    PluviometrosService.list().then(function(result) {
      $scope.pluviometros = result.data;
    }).finally(LoadingService.hideLoading);
  };

  initialize();

  $scope.changeFile = function() {
    var error = function() {
      LoadingService.hideLoading();
      MessagesService.alert('Não foi possível carregar o arquivo');
    };

    var setFile = function() {
      LoadingService.showLoading();

      var fileReader = new FileReader();
      fileReader.onload = function(fileData) {
        $scope.parametros.file = fileData.target.result;
      };

      fileReader.onloadend = function() {
        LoadingService.hideLoading();
      };

      fileReader.readAsDataURL($scope.pluviometroFile);
    };

    if ($scope.pluviometroFile && $scope.pluviometroFile.type.match(textType)) {
      setFile();
    } else {
      $scope.parametros.file = null;
      $scope.pluviometroFile = null;
      angular.element("input[type='file']").val(null);
      error();
    }
  };

  $scope.upload = function() {
    LoadingService.showLoading();
    PluviometrosIntegracaoService.upload({
      cd_produtor: $scope.parametros.pluviometro.cd_produtor,
      cd_pluviometro: $scope.parametros.pluviometro.cd_pluviometro,
      tipo: $scope.parametros.tipo,
      arquivo: $scope.parametros.file
    }).then(function(result) {
      LoadingService.hideLoading();
      MessagesService.alert('Processados ' + result.data + ' registros');
      $scope.reset();
    }, function() {
      LoadingService.hideLoading();
      MessagesService.alert('Erro ao fazer upload do arquivo. Tente novamente');
    });
  };

});
